// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1MRsT","range":"MonthRangeSwitch_range__2ulc4","disabled":"MonthRangeSwitch_disabled__2031f"};